export { VectorBanner } from './VectorBanner';
